import { CalendarIcon, HomeIcon, ClockIcon, CalendarDaysIcon, UserGroupIcon, BuildingOffice2Icon, StopIcon } from '@heroicons/react/24/outline'
import React, { useEffect, useState } from 'react'
import MobileSidebar from '../../components/MainLayout/MobileSidebar'
import StaticSidebar from '../../components/MainLayout/StaticSidebar'
import Header from '../../components/MainLayout/Header'
import { Outlet } from 'react-router-dom'


const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, permissionRole: ['EMPLOYEE', 'BUSINESSOWNER', 'ADMIN'] },
  { name: 'Roster', href: '/roster', icon: CalendarIcon, permissionRole: ['EMPLOYEE'] },
  { name: 'Timesheet', href: '/timesheet', icon: ClockIcon, permissionRole: ['EMPLOYEE']},
  // { name: 'Leave', href: '/leave', icon: StopIcon, permissionRole: ['EMPLOYEE']},
  { name: 'Manage Roster', href: '/manage-roster', icon: CalendarDaysIcon, permissionRole: ['BUSINESSOWNER'] },
  { name: 'Weeky Time Sheet', href: '/weekly-timesheet', icon: ClockIcon, permissionRole: ['BUSINESSOWNER'] },
  { name: 'Manage Employees', href: '/manage-employees', icon: UserGroupIcon, permissionRole: ['BUSINESSOWNER'] },
  { name: 'Your Business', href: '/your-business', icon: BuildingOffice2Icon, permissionRole: ['BUSINESSOWNER'] },
  { name: 'Manage Businesses', href: '/manage-businesses', icon: BuildingOffice2Icon, permissionRole: ['ADMIN'] },
]

const teams = [
  { id: 1, name: 'Heroicons', href: '#', initial: 'H', current: false },
  { id: 2, name: 'Tailwind Labs', href: '#', initial: 'T', current: false },
  { id: 3, name: 'Workcation', href: '#', initial: 'W', current: false },
]

const userNavigation = [
  { name: 'Your profile', href: '/profile' },
]

const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ')
}

const MainLayout = ({content}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div>
      <MobileSidebar navigation={navigation} teams={teams} classNames={classNames} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>

      <StaticSidebar navigation={navigation} teams={teams} classNames={classNames}/>

      <div className="lg:pl-72">
        <Header userNavigation={userNavigation} setSidebarOpen={setSidebarOpen}/>


        <main className="py-10">
          <div className="px-4 sm:px-6 lg:px-8">

            {/* Outlet will change the page */}
            <Outlet context={[classNames]}/> 

          </div>
        </main>
      </div>      
    </div>
  )
}

export default MainLayout